import ConfirmConnection from './ConfirmConnection'

export default ConfirmConnection
